module.exports = __webpack_public_path__ + "media/components/ImpactBlock/static/handsgreen2-92bdf73f6fb2b4acdf3cd0f917b246ab.jpg";